// bibliotecas externas
import React, { useEffect, useRef, useState } from "react";
import { Spinner } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";

// context
import { MatchContext } from "../../providers/match";

// componentes
import Room from "../rooms";

// services
import { getRoommatesRoom } from "../../utils/services/roommates";

// store
import { createUser, reset } from "../../store/users";

// utils
import { Ienums } from "../../utils/interface";
import { getBackgroundGradient } from "../../utils/color";

export default function Match() {
  const { idParticipant, idEvent, setNewContextRefresh, matchConfig, t } =
    React.useContext(MatchContext);
  const { users } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  // state de carregamento
  const [loading, setLoading] = useState(true);

  // ref auxiliar (evita updates após unmount)
  const isMountedRef = useRef(false);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    setNewContextRefresh();
  }, []);
  useEffect(() => {
    if (idParticipant && idEvent) getStatus();
  }, [idParticipant, idEvent]);

  // busca o status da sala do participante (eventId, participantId) e popula os usuários no redux conforme o retorno da API
  function getStatus(eventId = idEvent, participantId = idParticipant) {
    getRoommatesRoom(eventId, participantId)
      .then((res) => {
        if (!isMountedRef.current) return;

        const roomNotFound = res.message === "ROOMMATE_ROOMS_NOT_FOUND";
        const shouldCreateChooser =
          roomNotFound &&
          (users.length === 0 ||
            users.filter((e) => e.status === Ienums.PENDING_ACCEPT).length > 0);

        if (shouldCreateChooser) {
          dispatch(reset([]));
          dispatch(
            createUser({
              ...res.data,
              type: Ienums.CHOOSER,
              status: Ienums.COMPLETED,
              order: users.length + 1,
              picture: res?.data?.picture ?? null,
            }),
          );
        }

        if (res.message === Ienums.CHOOSER || res.message === Ienums.CHOOSEN) {
          dispatch(reset([]));
          res.data.dataRommateRoom.forEach((el) => {
            let {
              roommateId,
              login,
              status,
              order,
              chooser,
              hostingRestriction,
            } = el;
            dispatch(
              createUser({
                id: roommateId,
                name: login.name,
                email: login.email,
                status: status,
                order: order,
                type: chooser ? Ienums.CHOOSER : Ienums.CHOOSEN,
                hostingRestriction: hostingRestriction,
                picture: el?.login?.picture ?? null,
              }),
            );
          });
        }

        setLoading(false);
      })
      .catch((err) => {
        alert(t("Erro na requisição, atualize a página."));
        if (isMountedRef.current) setLoading(false);
      });
  }
  return (
    <div
      className="container-main"
      style={{
        background: getBackgroundGradient(matchConfig?.colorBackground),
        padding: "20px 0",
      }}
    >
      {loading ? (
        <Spinner color="light" />
      ) : (
        users.length > 0 && <Room getStatus={getStatus} />
      )}
    </div>
  );
}
